const getThumbnailPosition = thumnbsAttr => thumbnailEl => parseInt(thumbnailEl.getAttribute(thumnbsAttr))
export default getThumbnailPosition;